var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13C9.21875 13 9 13.25 9 13.5V14C9 14.5625 8.53125 15 8 15H3C2.4375 15 2 14.5625 2 14V6C2 5.46875 2.4375 5 3 5H6.5C6.75 5 7 4.78125 7 4.5C7 4.25 6.75 4 6.5 4H2.96875C1.875 4 0.96875 4.90625 0.96875 6L1 14C1 15.125 1.875 16 3 16H8C9.09375 16 10 15.125 10 14V13.5C10 13.25 9.75 13 9.5 13ZM16.6875 2.71875L14.2812 0.3125C14.0938 0.125 13.8438 0 13.5625 0H10C8.875 0 8 0.90625 8 2V10C8 11.125 8.875 12 10 12H15C16.0938 12 17 11.125 17 10V3.4375C17 3.15625 16.875 2.90625 16.6875 2.71875ZM14 1.4375L15.5625 3H14V1.4375ZM16 10C16 10.5625 15.5312 11 15 11H10C9.4375 11 9 10.5625 9 10V2C9 1.46875 9.4375 1 10 1H13V3C13 3.5625 13.4375 4 14 4H16V10Z",
    fill: "#8E9195"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3cc722226765069787891863e2f143c9.svg";
export { ForwardRef as ReactComponent };